import { ac } from '../actions'

export const SHOW_LOADING_BAR = 'SHOW_LOADING_BAR'
export const HIDE_LOADING_BAR = 'HIDE_LOADING_BAR'

export const showLoadingBar = () => ac(SHOW_LOADING_BAR)
export const hideLoadingBar = () => ac(HIDE_LOADING_BAR)
